import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { AsyncAjaxDelete, AsyncAjaxGet, AsyncAjaxPost } from "../../Common/AsyncAjaxService";
import { ValidateToken } from "vagaro-website-rendering/src/components/Utilities/BusinessData";



const VagaroAPIEnum = {

    //Sections
    getSectionList: "section/list",
    addSection:"section/add",
    editSection:"section/edit",
    deleteSection:"section/delete",
    setSectionPrivate:"section/private",
    setSectionPublic:"section/public",
    updateCategoriesForSection:"section/editcategory",
    getSectionDetails:"section/",
    changeSectionSequence:"section/changesquance",
    duplicateSection:"section/duplicate",

    //Categories
    getCategories:"section/category",
    addEditCategory:"section/addeditcategory",
    deleleCategory:"section/deletecategory?categoryId=",
    changeCategorySequence:"section/changesquancecategory"

}

export async function GetSectionList(userContext:UserContext,categoryId:string,onComplete:(data:any)=>void,onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url  = VagaroAPIEnum.getSectionList;

    let body = JSON.stringify({CategoryId:categoryId});

    await AsyncAjaxPost(url,body,userContext.accessToken,(data:any)=>{ onComplete(data?.data?.data)},onError);
}

export async function GetSectionDetails(userContext:UserContext,sectionId:string,onComplete:(data:any)=>void,onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url  = VagaroAPIEnum.getSectionDetails+sectionId;

    await AsyncAjaxGet(url,userContext.accessToken,(data:any)=>{ onComplete(data?.data?.data)},onError);

}

export async function GetSectionCategories(userContext:UserContext,onComplete:(data:any)=>void,onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url  = VagaroAPIEnum.getCategories;

    await AsyncAjaxGet(url,userContext.accessToken,(data:any)=>{ onComplete(data?.data?.data)},onError);
}

export async function AddSection(userContext:UserContext,categories:string[],contentString:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let user = userContext.userId;

    let body = JSON.stringify({CategoryId:categories,Content:contentString,Created_By:user});

    await AsyncAjaxPost(VagaroAPIEnum.addSection,body,userContext.accessToken,onComplete,onError);
}

export async function EditSection(userContext:UserContext,sectionId:string, categories:string[],contentString:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let user = userContext.userId;

    let body = JSON.stringify({Id:sectionId,CategoryId:categories,Content:contentString,Modified_by:user});

    await AsyncAjaxPost(VagaroAPIEnum.editSection,body,userContext.accessToken,onComplete,onError);
}

export async function AddCategory(userContext:UserContext,categoryName:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await UpdateCategory(userContext,"0",categoryName,onComplete,onError);
}

export async function DeleteCategory(userContext:UserContext,categoryId:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.deleleCategory+categoryId;

    await AsyncAjaxDelete(url,userContext.accessToken,onComplete,onError);
}

export async function UpdateCategory(userContext:UserContext,categoryId:string,categoryName:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){
    await ValidateToken(userContext);

    let url = VagaroAPIEnum.addEditCategory;
    let body = JSON.stringify({Id:categoryId,Name:categoryName});

    await AsyncAjaxPost(url,body,userContext.accessToken,onComplete,onError);
}   

export async function DeleteSection(userContext:UserContext,sectionId:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.deleteSection;
    let body = JSON.stringify({Id:sectionId,Modified_by:userContext.userId});

    await AsyncAjaxPost(url,body,userContext.accessToken,onComplete,onError);

}

export async function DuplicateSection(userContext:UserContext,sectionId:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.duplicateSection;
    let body = JSON.stringify({Id:sectionId,Modified_by:userContext.userId});

    await AsyncAjaxPost(url,body,userContext.accessToken,onComplete,onError);

}


export async function SetSectionPrivateOrPublic(isPrivate:boolean,userContext:UserContext,sectionId:string,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url = (isPrivate)? VagaroAPIEnum.setSectionPrivate:VagaroAPIEnum.setSectionPublic;
    let body = JSON.stringify({Id:sectionId,Modified_by:userContext.userId});

    await AsyncAjaxPost(url,body,userContext.accessToken,onComplete,onError);

}


export async function UpdateCategoriesForSection(userContext:UserContext,sectionId:string,newCategories:string[],onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.updateCategoriesForSection;
    let body = JSON.stringify(
        {
        Id:sectionId,
        CategoryId:newCategories,
        Modified_by:userContext.userId
        }
    );

    await AsyncAjaxPost(url,body,userContext.accessToken,onComplete,onError);

}

export async function ChangeCategorySequence(userContext:UserContext,categoryId:string,original:number,destination:number,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.changeCategorySequence;
    let body = JSON.stringify({CategoryId:categoryId,DestinationCategoryRank:destination,SourceCategoryRank:original});

    await AsyncAjaxPost(url,body,userContext.accessToken,onComplete,onError);
}

export async function ChangeSectionSequence(userContext:UserContext,sectionId:string,original:number,destination:number,onComplete:(data:any)=>void=(data)=>{},onError:(error:any)=>void=(error:any)=>{}){

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.changeSectionSequence;
    let body = JSON.stringify({SectionId:sectionId,DestinationSectionRank:destination,SourceSectionRank:original,Modified_By:userContext.userId});

    await AsyncAjaxPost(url,body,userContext.accessToken,onComplete,onError);
}